const Banner = () => {
  return (
    <div className="contact-banner">
      <h1>Contact Us</h1>
      <p>{`Home > Contact`}</p>
    </div>
  );
};

export default Banner;
